import { AppDispatch } from "store/store";
import { httpWrapper } from "utils/http";
import { SMS_API_BASE } from "../../constants";
import { handleError, CustomError } from "errors/errors";
import {
  nextEngineAuthorizeStart,
  nextEngineAuthorizeSuccess,
  nextEngineAuthorizeError,
} from "./ClientLinkSlice";
import { ClientNextEngineLinkSimple } from "api/sms-api";

export const nextEngineAuthorize = (
  uid: string,
  state: string,
  onSuccess: () => void
) => async (dispatch: AppDispatch) => {
  try {
    dispatch(nextEngineAuthorizeStart());
    const client: ClientNextEngineLinkSimple = await httpWrapper<ClientNextEngineLinkSimple>(
      "POST",
      `${SMS_API_BASE}/client_next_engine/authorize_with_session`,
      { uid, state }
    );
    dispatch(nextEngineAuthorizeSuccess(client));
    onSuccess();
  } catch (e) {
    handleError(e);
    dispatch(nextEngineAuthorizeError(CustomError.Unknown));
  }
};
